export default __webpack_public_path__ + "static/media/growth.26f973b0.png";